import React, { useMemo } from 'react';
import { Button, Typography, Select, InputNumber, message } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
const { Text } = Typography;

const SeccionCombosModal = ({
    productosDB, producto, calcularMargenDesdePrecio, setMargenGanancia, setProducto
}) => {
    
    // Convertir productos y variantes en una sola lista plana para el Select
    const opcionesSelect = useMemo(() => {
        const opciones = [];
        productosDB.filter(p => !p.es_combo).forEach(p => {
            if (p.has_variants && p.variantes && p.variantes.length > 0) {
                p.variantes.forEach(v => {
                    opciones.push({
                        label: `${p.nombre} - ${v.atributos?.nombre || 'Var'}`,
                        value: `var_${v.id}`,
                        producto_id: p.id,
                        variante_id: v.id,
                        costo: v.precio_compra || p.precio_compra || 0,
                        codigo_barras: v.codigo_barras || '',
                        codigo_interno: v.codigo_interno || ''
                    });
                });
            } else {
                opciones.push({
                    label: p.nombre,
                    value: `prod_${p.id}`,
                    producto_id: p.id,
                    variante_id: null,
                    costo: p.precio_compra || 0,
                    codigo_barras: p.codigo_barras || '',
                    codigo_interno: p.codigo_interno || ''
                });
            }
        });
        return opciones;
    }, [productosDB]);

    return (
        <div style={{ background: '#f8fafc', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0', marginBottom: '20px' }}>
            <Text strong style={{ display: 'block', marginBottom: '12px', fontSize: '15px' }}>Arma tu Combo</Text>

            <Select
                showSearch
                style={{ width: '100%', height: '45px', marginBottom: '15px' }}
                placeholder="Busca por nombre, código de barras o SKU..."
                filterOption={(input, option) => {
                    const busqueda = input.toLowerCase();
                    return (
                        (option?.label ?? '').toLowerCase().includes(busqueda) ||
                        (option?.codigo_barras ?? '').toLowerCase().includes(busqueda) ||
                        (option?.codigo_interno ?? '').toLowerCase().includes(busqueda)
                    );
                }}
                options={opcionesSelect}
                optionRender={(option) => (
                    <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.2', padding: '4px 0' }}>
                        <Text strong style={{ fontSize: '14px' }}>{option.data.label}</Text>
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                            {[
                                option.data.codigo_barras ? `Barras: ${option.data.codigo_barras}` : null,
                                option.data.codigo_interno ? `SKU: ${option.data.codigo_interno}` : null
                            ].filter(Boolean).join(' • ') || 'Sin códigos asignados'}
                        </Text>
                    </div>
                )}
                value={null}
                onChange={(val, option) => {
                    const itemsActuales = producto.comboItems || [];
                    // Validación modificada para considerar la variante
                    const existe = itemsActuales.find(item => item.producto_id === option.producto_id && item.variante_id === option.variante_id);
                    if (existe) return message.warning("Este producto/variante ya está en el combo.");

                    const nuevosItems = [...itemsActuales, { 
                        producto_id: option.producto_id, 
                        variante_id: option.variante_id,
                        nombre: option.label, 
                        cantidad: 1, 
                        costo_unitario: option.costo 
                    }];
                    
                    const nuevoCostoTotal = nuevosItems.reduce((acc, item) => acc + ((Number(item.precio_compra) || Number(item.costo_unitario) || 0) * Number(item.cantidad)), 0);

                    const nuevoMargen = calcularMargenDesdePrecio(nuevoCostoTotal, producto.precioVenta);
                    setMargenGanancia(nuevoMargen);
                    setProducto({ ...producto, comboItems: nuevosItems, precioCompra: nuevoCostoTotal });
                }}
            />

            {(producto.comboItems || []).length > 0 && (
                <table style={{ width: '100%', background: '#fff', border: '1px solid #cbd5e1', borderRadius: '8px', overflow: 'hidden', borderCollapse: 'collapse' }}>
                    <thead style={{ background: '#f1f5f9', fontSize: '12px', color: '#475569' }}>
                        <tr>
                            <th style={{ padding: '8px', textAlign: 'left' }}>Producto</th>
                            <th style={{ padding: '8px', textAlign: 'center', width: '100px' }}>Cant.</th>
                            <th style={{ padding: '8px', textAlign: 'right', width: '120px' }}>Costo Subtotal</th>
                            <th style={{ padding: '8px', textAlign: 'center', width: '50px' }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {producto.comboItems.map((item, index) => {
                            const costoBase = Number(item.precio_compra) || Number(item.costo_unitario) || 0;

                            return (
                                <tr key={index} style={{ borderTop: '1px solid #cbd5e1' }}>
                                    <td style={{ padding: '8px', fontSize: '13px', fontWeight: '500' }}>{item.nombre}</td>
                                    <td style={{ padding: '8px', textAlign: 'center' }}>
                                        <InputNumber
                                            min={1}
                                            controls={false}
                                            autoFocus
                                            value={item.cantidad}
                                            onFocus={(e) => e.target.select()}
                                            onChange={(val) => {
                                                const nuevosItems = [...producto.comboItems];
                                                nuevosItems[index].cantidad = val || 1;

                                                const nuevoCostoTotal = nuevosItems.reduce((acc, i) => acc + ((Number(i.precio_compra) || Number(i.costo_unitario) || 0) * Number(i.cantidad)), 0);

                                                const nuevoMargen = calcularMargenDesdePrecio(nuevoCostoTotal, producto.precioVenta);
                                                setMargenGanancia(nuevoMargen);
                                                setProducto({ ...producto, comboItems: nuevosItems, precioCompra: nuevoCostoTotal });
                                            }}
                                        />
                                    </td>
                                    <td style={{ padding: '8px', textAlign: 'right', fontSize: '13px' }}>
                                        ${(costoBase * Number(item.cantidad)).toLocaleString('es-CO')}
                                    </td>
                                    <td style={{ padding: '8px', textAlign: 'center' }}>
                                        <Button danger type="text" icon={<DeleteOutlined />} onClick={() => {
                                            const nuevosItems = producto.comboItems.filter((_, i) => i !== index);
                                            const nuevoCostoTotal = nuevosItems.reduce((acc, i) => acc + ((Number(i.precio_compra) || Number(i.costo_unitario) || 0) * Number(i.cantidad)), 0);
                                            const nuevoMargen = calcularMargenDesdePrecio(nuevoCostoTotal, producto.precioVenta);
                                            setMargenGanancia(nuevoMargen);
                                            setProducto({ ...producto, comboItems: nuevosItems, precioCompra: nuevoCostoTotal });
                                        }} />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            )}
        </div>
    )
}

export default SeccionCombosModal;